import state from './branch.state'
import mutations from './branch.mutations'
import actions from './branch.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
